import { EmployerFacility } from '~/types/hlx/employerFacility';
import { deleteData, getData, patchData, postData } from '~/utils/service';
import { EmployerFacilityValues } from './types';

type SubmitEvent = {
  type: string;
  payload: { data: EmployerFacilityValues };
};

export const createEmployerFacility = async ({ input }: { input: unknown }) => {
  const data = (input as { event: SubmitEvent }).event.payload.data;
  return await postData('employerFacility', {
    data,
    transformRequest: employerFacilityValuesToApi,
  });
};

export const getEmployerFacilities: () => Promise<EmployerFacility[]> = async () => {
  return await getData('employerFacility');
};

export const patchEmployerFacility = async ({ input }: { input: unknown }) => {
  const data = (input as { event: SubmitEvent }).event.payload.data;
  if (typeof data.id !== 'number') {
    throw new Error('Missing employer facility id for PATCH');
  }
  return await patchData('employerFacility', {
    data,
    pathParams: { employerFacilityId: data.id.toString() },
    transformRequest: employerFacilityValuesToApi,
  });
};

export const deleteEmployerFacility = async ({ input }: { input: unknown }) => {
  const id = (input as { event: { payload: { id: number } } }).event.payload.id;
  return await deleteData('employerFacility', {
    pathParams: { employerFacilityId: id.toString() },
  });
};

export const employerFacilityValuesToApi = (data: EmployerFacilityValues) => {
  const transformedData: Partial<EmployerFacility> = {
    clinicalSettingCategory: data.clinicalSettingCategory.value,
    clinicalSetting: data.clinicalSetting.value,
    facilitySize: data.facilitySize.value,
    areaType: data.areaType.value,
    facilityName: data.facilityName.label,
    facilityNpi: data.facilityNpi ?? undefined,
    facilityId: data.facilityId ? parseInt(data.facilityId) : undefined,
    isPrimary: data.isPrimary,
  };
  return JSON.stringify(transformedData);
};
